<template>
  <div>
    <z-loading 
      v-if="starting" 
      height="100vh"
      message="Aguarde. Carregando o sistema..."
      :loading="starting" 
    ></z-loading>
    <slot v-else></slot>

    <z-dialogo-impressao 
      ref="dialogoImpressao" 
      titulo="Impressão"
      :url-impressao="urlImpressao"
      @fechar="urlImpressao = ''"
    ></z-dialogo-impressao>
  </div>
</template>


<script setup>
import { ref, onMounted, computed, provide, getCurrentInstance } from 'vue'
import { useConfigStore } from '@/app/store/pinia/configuracoes';
import sistemaApi from '@/app/services/sistema';
import { useGlobalStore } from '@/app/store/pinia/global';

const { proxy } = getCurrentInstance();
const globalStore = useGlobalStore();
const configStore = useConfigStore();

const $store = proxy.$store;
const $vuetify = proxy.$vuetify;
const $storage = proxy.$storage;
const $cookie = proxy.$cookie;
const $config = proxy.$config;

const starting = ref(true);
const urlImpressao = ref('');
const dialogoImpressao = ref(null);

const lojas = computed(() => {
  return $store.state.listas.lojas;
});

const loja_padrao = computed(() => {
  return $store.state.listas.lojas.find((loja) => loja.padrao == 1);
});

provide('$imprimir', imprimir);

onMounted(() => {
    log('Starting App...');
    setCorTema();


    starting.value = true;
    // setTimeout(() => {
      init();
    // }, 2000);
});


async function init() {
      
  try {
    log('Starting Init...');

    setCorTema();

    await carregarConfiguracoes();
    await configStore.carregarConfiguracoes();

    await carregarLojas();

    setLoja();

    await carregarConfiguracaoTerminal();

    log('Starting Finished...');

  } catch (error) {
    throw error;
  } finally {
    starting.value = false;
  }
}

function log(msg) {
  if (!$config.IS_PRODUCTION) {
    console.log(msg);
  }
}

async function carregarConfiguracoes() {
  log('Loading Configurações...');

  await $store.dispatch('carregarConfiguracoes');
}

async function carregarLojas() {
  log('Loading Lojas...');

  await $store.dispatch("listas/lojas");
}

function setCorTema(cor = null) {
  log('Setting Cor Tema...');

  if (cor) {
    $vuetify.theme.themes.light.primary = cor;
    return;
  }
  
  if ($storage.has("loja")) {
    let loja = $storage.get("loja");
    $vuetify.theme.themes.light.primary = loja.cor_primaria;
  }
}

function setLoja() {
  log('Setting up Loja...');

  if ($storage.has("loja")) {
    let loja = $storage.get("loja");
    $store.commit("lojas/SET_LOJA_ATUAL", loja);
    $cookie.setCookie("loja_id", loja.id, 365);
    setCorTema(loja.cor_primaria);
  } else {
    usarLojaPadrao();
  }
}

async function usarLojaPadrao() {
  log('Setting up Loja Padrão...');

  $storage.set("loja",  loja_padrao.value);
  setCorTema(loja_padrao.value.cor_primaria);
  $store.commit("lojas/SET_LOJA_ATUAL", loja_padrao.value);
  $cookie.setCookie("loja_id", loja_padrao.value.id, 365);
  // window.location.reload();
}

async function registrarTerminal() {
  log('Registrando terminal...');
  const { terminal } = await sistemaApi.registrarTerminal();

  $cookie.setCookie("terminal_id", terminal.terminal_id, 365);
  return terminal.terminal_id;
}

async function carregarConfiguracaoTerminal() {
  log('Carregando Configuração do Terminal...');

  let terminal_id = $cookie.getCookie("terminal_id");

  if (!terminal_id) {
    terminal_id = await registrarTerminal();
  }

  const configuracoes = await sistemaApi.loadTerminalConfig();

  $store.commit("ADD_CONFIGURACOES", configuracoes);
  configStore.ADD_CONFIGURACOES(configuracoes);
  log(configuracoes);
}

async function imprimir(url, nome_arquivo) {
  dialogoImpressao.value.abrir(url, nome_arquivo);
}


</script>

<style lang="scss" scoped>

</style>